module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "m-l-50 m-t-30 w-500"
  }, [_c('el-form', {
    ref: "form",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "表单标识",
      "prop": "name"
    }
  }, [_c('span', [_vm._v("form_")]), _vm._v(" "), _c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.name),
      expression: "form.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-150",
    domProps: {
      "value": (_vm.form.name)
    },
    on: {
      "input": function($event) {
        _vm.form.name = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "表单名称",
      "prop": "title"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.title),
      expression: "form.title",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.title)
    },
    on: {
      "input": function($event) {
        _vm.form.title = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "表描述"
    }
  }, [_c('el-input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.form.des),
      expression: "form.des",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "h-40 w-200",
    domProps: {
      "value": (_vm.form.des)
    },
    on: {
      "input": function($event) {
        _vm.form.des = (typeof $event === 'string' ? $event.trim() : $event)
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "复制表",
      "prop": "model_id"
    }
  }, [_c('el-select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.model_id),
      expression: "form.model_id"
    }],
    attrs: {
      "clearable": "",
      "filterable": true
    },
    domProps: {
      "value": (_vm.form.model_id)
    },
    on: {
      "input": function($event) {
        _vm.form.model_id = $event
      }
    }
  }, _vm._l((_vm.models), function(option) {
    return _c('el-option', {
      attrs: {
        "label": option.title,
        "value": option.id
      }
    })
  }))]), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.isLoading
    },
    on: {
      "click": function($event) {
        _vm.add()
      }
    }
  }, [_vm._v("提交")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.goback()
      }
    }
  }, [_vm._v("返回")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-82d24370!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Model/add.vue
// module id = 1949
// module chunks = 2